<script lang="ts">
    export let stars: number
    export let identifier: string
    let offset = (stars % 1) * 100
</script>

<div class="stars">
    {#each Array.from({ length: 5 }, (v, k) => k) as star, i}
        <svg
            class="star"
            viewBox="0 0 20 20"
            fill="none"
            class:filled="{stars >= i + 1}"
            xmlns="http://www.w3.org/2000/svg"
        >
            {#if Math.ceil(stars) == i + 1}
                <defs>
                    <linearGradient id="{`id-${i}-${identifier}`}" x1="0%" x2="100%">
                        <stop offset="{offset}%" stop-color="red"></stop>
                        <stop offset="{offset}%" stop-color="transparent"></stop>
                    </linearGradient>
                </defs>
            {/if}
            <path
                d="M18.75 8.125h-6.719L10 1.875l-2.031 6.25H1.25l5.469 3.75-2.11 6.25L10 14.219l5.39 3.906-2.109-6.25 5.469-3.75z"
                stroke="red"
                stroke-linejoin="round"
                fill="{`url(#id-${i}-${identifier})`}"></path>
        </svg>
    {/each}
</div>

<style lang="less">
    .stars {
        display: flex;
        gap: 1px;
        height: 20px;

        .star {
            height: 17.5px;
            width: 18.7px;
            background-color: transparent;
            border: 0px solid rgb(255, 0, 0);
            padding: 0px;
            &.filled path {
                stroke: var(--primary) !important;
                fill: var(--primary);
            }
        }
    }
</style>
